<div class="onboarding-vessels-page">
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">
      <div class="filter-header">
        <div class="filter-header__title">
          <mat-icon aria-hidden="true">filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="closeFilterDrawer()">close</mat-icon>
      </div>

      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-section">
          <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
            IMO Number
          </label>
          <input
            type="text"
            class="form-control"
            id="imoNumber"
            formControlName="imoNumber"
            placeholder="Enter IMO Number"
            autocomplete="off"
          />
        </div>

        <div class="filter-section vessel-name-field">
          <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
            Vessel Name
          </label>
          <input
            type="text"
            class="form-control"
            id="vesselName"
            formControlName="vesselName"
            placeholder="Enter Vessel Name"
            autocomplete="off"
            [matAutocomplete]="vesselAuto"
            (input)="onVesselNameInput($event)"
          />
          <mat-autocomplete
            #vesselAuto="matAutocomplete"
            panelClass="onboarding-vessel-autocomplete-panel"
            (optionSelected)="onVesselNameSelected($event)"
          >
            <mat-option *ngIf="showNoVesselSuggestions" disabled>
              No matching vessels found
            </mat-option>
            <mat-option
              *ngFor="let vessel of filteredVesselSuggestions"
              [value]="vessel.vessel_name"
            >
              <span class="vessel-suggestion-row">
                <span class="vessel-suggestion-name">{{ vessel.vessel_name }}</span>
                <span class="vessel-suggestion-imo">{{ vessel.vessel_imo }}</span>
              </span>
            </mat-option>
          </mat-autocomplete>
        </div>
      </form>

      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>
        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>
    </div>
  </div>
  <div class="filter-overlay" *ngIf="isFilterOpen" (click)="closeFilterDrawer()"></div>

  <div class="container" [ngClass]="{ 'dark-mode': isDarkMode(), 'light-mode': !isDarkMode() }">
  <header class="details-header" [class.details-header--list]="isListView">
    <div class="header-left">
      <app-back-button (back)="goBack()"></app-back-button>
    </div>
    <h1 class="header-title">{{ pageTitle }}</h1>
    <div class="header-right">
      <button
        *ngIf="isListView"
        type="button"
        class="filter-top-btn"
        (click)="isFilterOpen = true"
        matTooltip="Table Filter"
        aria-label="Open table filters"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </header>

  <section class="vessel-list-section" *ngIf="isListView">
    <h3 class="vessel-list-title">Vessel List</h3>

    <div class="vessel-list-table-wrapper">
      <div class="vessel-list-table-scroll scroll-bar">
        <table
          class="vessel-list-table"
          [ngClass]="{ 'dark-table': isDarkMode() }"
        >
          <colgroup>
            <col class="col-vessel-name" />
            <col class="col-imo-number" />
          </colgroup>
          <thead>
            <tr>
              <th class="col-vessel-name">Vessel Name</th>
              <th class="col-imo-number">IMO Number</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of paginatedVesselList"
              (click)="filterByVesselAndImo(item.vessel_name, item.vessel_imo)"
            >
              <td class="col-vessel-name">{{ item.vessel_name }}</td>
              <td class="col-imo-number">{{ item.vessel_imo }}</td>
            </tr>
            <tr *ngIf="!paginatedVesselList.length" class="vessel-list-empty-row">
              <td colspan="2">No vessels found.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <mat-paginator
        class="vessel-list-paginator"
        [length]="filteredData.length || 0"
        [pageIndex]="currentPage"
        [pageSizeOptions]="[100]"
        [pageSize]="itemsPerPage"
        (page)="onPageChange($event)"
        [ngClass]="{ 'dark-paginator': isDarkMode() }"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </section>

  <ng-template #moduleVesselSections>
    <div class="tcp-speed-consumption-section cargo-heating-onboarding-section">
      <h3
        class="title"
        style="margin-top: 10px; margin-bottom: 15px; text-align: left; font-size: 18px; font-weight: 600;"
      >
        Cargo Heating Onboarding Details
      </h3>
      <app-cargo-heating-detail
        *ngIf="selectedImo"
        [vesselName]="vesselName"
        [selectedImo]="selectedImo"
        [detail]="cargoHeatingDetail"
        [loading]="isLoadingChDetail"
        [isDarkMode]="isDarkMode()"
        [embedded]="true"
        [sections]="cargoHeatingDetailSections"
        [savingSectionId]="savingCargoSectionId"
        (sectionSave)="saveCargoHeatingSection($event)"
      ></app-cargo-heating-detail>
    </div>
  </ng-template>

  <app-cargo-heating-detail
    *ngIf="isCargoHeatingDetailView"
    [vesselName]="getVesselCardName(selectedCargoHeatingVessel || cargoHeatingDetail || {})"
    [selectedImo]="getVesselCardImo(selectedCargoHeatingVessel || cargoHeatingDetail || {})"
    [detail]="cargoHeatingDetail"
    [loading]="isLoadingChDetail"
    [isDarkMode]="isDarkMode()"
    [sections]="cargoHeatingDetailSections"
    [savingSectionId]="savingCargoSectionId"
    (back)="resetFilter()"
    (edit)="editCargoHeatingConfiguration()"
    (sectionSave)="saveCargoHeatingSection($event)"
  ></app-cargo-heating-detail>

  <app-emission-detail
    *ngIf="isEmissionDetailView"
    [vesselName]="getVesselCardName(selectedEmissionVessel || emissionDetail || {})"
    [loading]="isLoadingEmissionDetail"
    [isDarkMode]="isDarkMode()"
    [sections]="emissionDetailSections"
    [savingSectionId]="savingEmissionSectionId"
    (back)="resetFilter()"
    (edit)="editEmissionConfiguration()"
    (sectionSave)="saveEmissionSection($event)"
  ></app-emission-detail>


  <!-- Port Performance detailed view -->
  <div class="port-vessel-detail" *ngIf="isPortDetailView">
    <!-- Speed & Consumption Section -->
    <div class="tcp-speed-consumption-section" *ngIf="(vesselTcpSpeedConsumption && vesselTcpSpeedConsumption.length > 0) || cpLimits">
      <h3 class="title" style="margin-top: 10px; margin-bottom: 15px; text-align: left; font-size: 18px; font-weight: 600;">Speed & Consumption Performance</h3>
      
      <div class="tcp-layout-container">
        <!-- Left Column: Speed & Consumption Cards -->
        <div class="tcp-curves-column" *ngIf="vesselTcpSpeedConsumption && vesselTcpSpeedConsumption.length > 0">
          <div class="tcp-grid">
            <div class="tcp-card" *ngFor="let item of vesselTcpSpeedConsumption; let idx = index" [ngClass]="{ 'dark-card': isDarkMode() }">
              <div class="tcp-card-header">
                <span class="vessel-title">{{ item.ship_name }} ({{ item.condition }})</span>
                <span class="vessel-subtitle">{{ item.client }} | {{ item.segment || 'N/A' }}</span>
              </div>
              
              <div class="tcp-table-container" *ngIf="activeLogEditCardIndex !== idx">
                <table class="tcp-table" [ngClass]="{ 'dark-table': isDarkMode() }">
                  <thead>
                    <tr>
                      <th>Speed (knots)</th>
                      <th style="text-align: right;">Consumption (MT/day)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let key of getObjectKeys(item.speed_consumption)">
                      <td class="speed-val">{{ key }}</td>
                      <td class="cons-val">{{ item.speed_consumption[key] }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Curve Logs Manager Button -->
              <div class="tcp-card-actions mt-3">
                <button type="button" class="btn btn-sm btn-outline-secondary w-100" (click)="toggleManageLogs(idx)">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;">settings</mat-icon>
                  {{ activeLogEditCardIndex === idx ? 'Close Log Manager' : 'Manage Logs' }}
                </button>
              </div>

              <!-- Log Manager Pane -->
              <div class="log-manager-pane mt-3 border-top pt-3" *ngIf="activeLogEditCardIndex === idx">
                <h5 style="font-size: 13px; font-weight: 600; color: #4a5568; margin-bottom: 12px;">Edit Speed & Consumption Points</h5>
                
                <!-- List of editable points -->
                <div class="log-points-list mb-3">
                  <!-- Header Row -->
                  <div class="log-point-row header-row" style="display: flex; font-weight: 600; font-size: 11px; color: #718096; padding-bottom: 4px; border-bottom: 1px solid #edf2f7; margin-bottom: 8px;">
                    <span style="flex: 1;">Speed (kts)</span>
                    <span style="flex: 1.5; padding-left: 8px;">Consumption (MT)</span>
                    <span style="width: 30px; text-align: center;">Action</span>
                  </div>

                  <!-- Rows -->
                  <div class="log-point-row" *ngFor="let point of localSpeedConsArray; let pIdx = index" style="display: flex; align-items: center; margin-bottom: 8px; gap: 8px;">
                    <div style="flex: 1; display: flex; align-items: center;">
                      <input type="number" (wheel)="$event.preventDefault()" step="0.1" class="form-control form-control-sm" style="height: 28px; font-size: 12px; padding: 2px 6px;"
                        [(ngModel)]="point.speed">
                      <span style="font-size: 12px; font-weight: 500; margin-left: 4px;">kts</span>
                    </div>
                    <div style="flex: 1.5; display: flex; align-items: center; gap: 4px;">
                      <input type="number" (wheel)="$event.preventDefault()" step="0.1" class="form-control form-control-sm" style="height: 28px; font-size: 12px; padding: 2px 6px;"
                        [(ngModel)]="point.cons">
                      <span style="font-size: 12px; font-weight: 500; margin-left: 4px;">MT</span>
                    </div>
                    <div style="width: 50px; display: flex; justify-content: flex-end;">
                      <button type="button" class="btn btn-sm btn-link text-danger p-0" style="display: flex; align-items: center;" (click)="localDeleteLogPoint(pIdx)">
                        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Add new point -->
                <div class="add-point-form border-top pt-2">
                  <h6 style="font-size: 11px; font-weight: 600; color: #718096; margin-bottom: 8px;">Add New Point</h6>
                  <div style="display: flex; gap: 8px; width: 100%;">
                    <input type="number" (wheel)="$event.preventDefault()" step="0.1" class="form-control form-control-sm" style="flex: 1; height: 32px; font-size: 12px;" placeholder="Speed (kts)" [(ngModel)]="newSpeedVal">
                    <input type="number" (wheel)="$event.preventDefault()" step="0.1" class="form-control form-control-sm" style="flex: 1; height: 32px; font-size: 12px;" placeholder="Cons (MT)" [(ngModel)]="newConsVal">
                    <button type="button" class="btn btn-sm btn-primary" style="flex: 0 0 40px; height: 32px; display: flex; align-items: center; justify-content: center; padding: 0;"
                      (click)="localSaveLogPoint(newSpeedVal, newConsVal)">
                      <mat-icon style="font-size: 20px; width: 20px; height: 20px;">add</mat-icon>
                    </button>
                  </div>
                  <div class="text-danger mt-1" style="font-size: 10px;" *ngIf="newSpeedError">
                    {{ newSpeedError }}
                  </div>
                  <div class="mt-3 text-end">
                    <button type="button" class="btn btn-sm btn-success" (click)="saveAllLogPoints(item)">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;">save</mat-icon> Save All Changes
                    </button>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <!-- Right Column: CP Weather Limits -->
        <div class="tcp-limits-column" *ngIf="cpLimits">
          <div class="cp-limits-card" [ngClass]="{ 'dark-card': isDarkMode() }">
            <div class="tcp-card-header d-flex justify-content-between align-items-center" style="flex-direction: row; margin-bottom: 12px; width: 100%;">
              <div style="display: flex; flex-direction: column;">
                <span class="vessel-title" style="display: block; line-height: 1.2;">Charter Party Limits</span>
                <span class="vessel-subtitle" style="display: block; margin-top: 4px; line-height: 1.2;">Weather & Performance Parameters</span>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm" *ngIf="!isEditingLimits" (click)="isEditingLimits = true">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;">edit</mat-icon> Edit
              </button>
            </div>
            
            <!-- Display Mode -->
            <div class="card-body" *ngIf="!isEditingLimits">
              <table class="tcp-table" [ngClass]="{ 'dark-table': isDarkMode() }">
                <tbody>
                  <tr>
                    <td><strong>Wind (BF)</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.wind_bf }}</td>
                  </tr>
                  <tr>
                    <td><strong>Significant Wave</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.sig_wave }} M</td>
                  </tr>
                  <tr>
                    <td><strong>Adverse Current</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.adverse_current }}</td>
                  </tr>
                  <tr>
                    <td><strong>Swell Height (DSS)</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.swell_height }} M</td>
                  </tr>
                  <tr>
                    <td><strong>Wind Wave</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.wind_wave }} M</td>
                  </tr>
                  <tr>
                    <td><strong>About S&C</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.about_sc }}</td>
                  </tr>
                  <tr>
                    <td><strong>Current Factor</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.current_factor }}</td>
                  </tr>
                  <tr>
                    <td><strong>Bad Weather Period</strong></td>
                    <td style="text-align: right; font-weight: 600;">{{ cpLimits.bad_weather_hours }} hrs</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Edit Mode -->
            <div class="card-body" *ngIf="isEditingLimits" style="padding-top: 8px;">
              <form [formGroup]="cpLimitsForm" (ngSubmit)="saveLimits()">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Wind (BF)</label>
                    <input type="number" (wheel)="$event.preventDefault()" class="form-control form-control-sm" formControlName="wind_bf">
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Significant Wave (m)</label>
                    <input type="number" (wheel)="$event.preventDefault()" step="0.01" class="form-control form-control-sm" formControlName="sig_wave">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Adverse Current</label>
                    <select class="form-select form-select-sm" formControlName="adverse_current">
                      <option value="Not Included">Not Included</option>
                      <option value="Included">Included</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Swell Height (DSS) (m)</label>
                    <input type="number" (wheel)="$event.preventDefault()" step="0.01" class="form-control form-control-sm" formControlName="swell_height">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Wind Wave (m)</label>
                    <input type="number" (wheel)="$event.preventDefault()" step="0.01" class="form-control form-control-sm" formControlName="wind_wave">
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">About S&C</label>
                    <select class="form-select form-select-sm" formControlName="about_sc">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Current Factor</label>
                    <select class="form-select form-select-sm" formControlName="current_factor">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="form-label" style="font-size: 11px; margin-bottom: 2px; font-weight: 600; color: #4a5568;" [ngClass]="{ 'dark-label': isDarkMode() }">Bad Weather Period (hrs)</label>
                    <input type="number" (wheel)="$event.preventDefault()" step="0.1" class="form-control form-control-sm" formControlName="bad_weather_hours">
                  </div>
                </div>
                
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-secondary btn-sm" (click)="isEditingLimits = false">Cancel</button>
                  <button type="submit" class="btn btn-primary btn-sm" [disabled]="cpLimitsForm.invalid">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


    <ng-container *ngIf="showModuleVesselSections">
      <ng-container *ngTemplateOutlet="moduleVesselSections"></ng-container>
    </ng-container>

    <div class="title-container port-vessel-detail__report-header">
      <h3 class="title">Detailed Report</h3>
      <mat-icon
        class="toggle-icon"
        matTooltip="{{
          isExpanded ? 'Click here to collapse' : 'Click here to expand'
        }}"
        (click)="toggleExpand()"
      >
        {{ isExpanded ? "fullscreen_exit" : "fullscreen" }}
      </mat-icon>
    </div>

    <div class="port-vessel-detail__loading" *ngIf="isLoadingPortDetail">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading detailed report…</span>
    </div>

    <div class="table-containerOne scroll-bar port-vessel-detail__table" *ngIf="!isLoadingPortDetail">
      <table
        class="mat-elevation-z8"
        id="style-4"
        matSort
        [ngClass]="{ 'dark-table': isDarkMode() }"
      >
        <thead class="sticky-header">
          <tr>
            <th>S.No</th>
            <th class="fixed-head">Vessel Name</th>
            <th>IMO Number</th>
            <th>Vessel Type</th>
            <th>Vessel Class</th>
            <th>Client</th>
            <th>Created At</th>
            <th>Created By</th>
            <th>Date Built</th>
            <th>Ship Yard</th>
            <th>Length Overall</th>
            <th>Breadth</th>
            <th>Summer Draft</th>
            <th>Summer Deadweight</th>
            <th>No. of Cargo Oil Pumps</th>
            <th>Cargo Pump Type</th>
            <th>Cargo Pump Capacity</th>
            <th>Cargo Pump Head</th>
            <th>Cargo Pump Steam Parameters</th>
            <th>Framo Cargo Pump</th>
            <th>Cargo Tank Capacity</th>
            <th>Max Discharge Rate</th>
            <th>Max Loading Rate</th>
            <th>Loading Avg. Peak Params</th>
            <th>Loading Electrical Load Params</th>
            <th>Auxiliary Engine Make</th>
            <th>Auxiliary Engine Capacity</th>
            <th>Auxiliary Engine Technical Parameters</th>
            <th>Ballast Pump Type</th>
            <th>Ballast Pump Capacity</th>
            <th>Ballast Pump Head</th>
            <th>Ballast Pump Steam Parameters</th>
            <th>Ballast Pump Electrical Parameters</th>
            <th>Framo Ballast Pump</th>
            <th>Ballast Tank Capacity</th>
            <th>Main Engine Make</th>
            <th>Main Engine Capacity</th>
            <th>Main Engine Technical Parameters</th>
            <th>Boiler Make</th>
            <th>Number of Boilers</th>
            <th>Boiler Capacity (kg/hr)</th>
            <th>Boiler Parameters</th>
            <th>Boiler Load %</th>
            <th>IGS</th>
            <th>IGG Parameters</th>
            <th>Inerting Parameters</th>
            <th>Tank Cleaning Avg. Peak</th>
            <th>Tank Cleaning Electrical Load</th>
            <th>Composite Boiler Capacity in Kg/hr</th>
            <th>Electrical Load Avg. Peak</th>
            <th>Idle Avg. Peak</th>
            <th>Idle Electrical Load</th>
            <th>Normal Sea Avg. Peak</th>
            <th>Normal Sea Electrical Load</th>
            <th>Maneuvering Avg. Peak</th>
            <th>Maneuvering Electrical Load</th>
            <th>Maneuvering Technical Parameters</th>
            <th>Cargo Ops Avg. Peak</th>
            <th>Cargo Ops Electrical Load</th>
            <th>TCP Parameters</th>
            <th>Speed Coefficients</th>
            <th>Diesel Power Packs</th>
            <th>Electric Power Packs</th>
            <th>Diversity Factor</th>
            <th>Vessel Status</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="!paginatedData.length">
            <td colspan="62" class="port-vessel-detail__empty-cell">
              No detailed port report is available for this vessel.
            </td>
          </tr>
          <tr *ngFor="let row of paginatedData; let i = index">
            <td>{{ i + 1 }}</td>
            <td class="fixed-col">{{ vesselName }}</td>
            <td>{{ row.vessel_imo }}</td>
            <td>{{ row.vessel_type }}</td>
            <td>{{ row.vessel_class }}</td>
            <td>{{ row.client }}</td>
            <td>{{ row.created_at }}</td>
            <td>{{ row.created_by }}</td>
            <td>{{ row.date_built }}</td>
            <td>{{ row.ship_yard }}</td>
            <td>{{ row.length_overall }}</td>
            <td>{{ row.breadth }}</td>
            <td>{{ row.summer_draft }}</td>
            <td>{{ row.summer_deadweight }}</td>
            <td>{{ row.number_of_cargo_oil_pumps }}</td>
            <td>{{ row.cargo_pump_type }}</td>
            <td>{{ row.cargo_pump_capacity }}</td>
            <td>{{ row.cargo_pump_head }}</td>
            <td>
              <table
                *ngIf="row.cargo_pump_steam_parameters?.length > 1"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let header of getSteamParamHeaders(
                          row.cargo_pump_steam_parameters
                        )
                      "
                    >
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let param of isExpanded
                        ? getSteamParamRows(row.cargo_pump_steam_parameters)
                        : [
                            getSteamParamRows(
                              row.cargo_pump_steam_parameters
                            ).slice(-1)[0]
                          ]
                    "
                  >
                    <td *ngFor="let val of param">{{ val }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>{{ row.framo_cargo_pump }}</td>
            <td>{{ row.cargo_tank_capacity }}</td>
            <td>{{ row.max_discharge_rate }}</td>
            <td>{{ row.max_loading_rate }}</td>
            <td>
              <div *ngIf="row.loading_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(row.loading_avg_peak_parameters)
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.loading_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.loading_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.loading_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.loading_electrical_load_parameters
                        : [
                            row.loading_electrical_load_parameters[
                              row.loading_electrical_load_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.loading_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ item[key] !== null ? item[key] : "—" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td>{{ row.auxilary_engine_make }}</td>
            <td>{{ row.auxilary_engine_capacity }}</td>
            <td>
              <table
                *ngIf="row.auxilary_engine_technical_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.auxilary_engine_technical_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.auxilary_engine_technical_parameters
                        : [
                            row.auxilary_engine_technical_parameters[
                              row.auxilary_engine_technical_parameters.length -
                                1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.auxilary_engine_technical_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td>{{ row.ballast_pump_type }}</td>
            <td>{{ row.ballast_pump_capacity }}</td>
            <td>{{ row.ballast_pump_head }}</td>
            <td>
              <table
                *ngIf="row.ballast_pump_steam_parameters?.length > 1"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let header of getSteamParamHeaders(
                          row.ballast_pump_steam_parameters
                        )
                      "
                    >
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let param of isExpanded
                        ? getSteamParamRows(row.ballast_pump_steam_parameters)
                        : [
                            getSteamParamRows(
                              row.ballast_pump_steam_parameters
                            ).slice(-1)[0]
                          ]
                    "
                  >
                    <td *ngFor="let val of param">{{ val }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table
                *ngIf="row.ballast_pump_electrical_parameters?.length > 1"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let header of getSteamParamHeaders(
                          row.ballast_pump_electrical_parameters
                        )
                      "
                    >
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let param of isExpanded
                        ? getSteamParamRows(
                            row.ballast_pump_electrical_parameters
                          )
                        : [
                            getSteamParamRows(
                              row.ballast_pump_electrical_parameters
                            ).slice(-1)[0]
                          ]
                    "
                  >
                    <td *ngFor="let val of param">{{ val }}</td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td>{{ row.framo_ballast_pump }}</td>
            <td>{{ row.ballast_tank_capacity }}</td>
            <td>{{ row.main_engine_make }}</td>
            <td>{{ row.main_engine_capacity }}</td>
            <td>
              <table
                *ngIf="row.main_engine_technical_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of row.main_engine_technical_parameters[0]
                          | keyvalue
                      "
                    >
                      {{ key.value }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.main_engine_technical_parameters
                        : [
                            row.main_engine_technical_parameters[
                              row.main_engine_technical_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td *ngFor="let key of item | keyvalue">
                      {{ key.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td>{{ row.boiler_make }}</td>
            <td>{{ row.number_of_boilers ?? row.numberOfBoilers ?? '—' }}</td>
            <td>{{ formatBoilerCapacityKgHr(row.boiler_capacity) }}</td>
            <td>
              <div *ngIf="row.boiler_parameters">
                <div *ngFor="let key of getObjectKeys(row.boiler_parameters)">
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.boiler_parameters[key] }}
                </div>
              </div>
            </td>

            <td>{{ row.boiler_load_percentage }}</td>
            <td>{{ row.igs }}</td>
            <td>
              <div *ngIf="row.igg_parameters">
                <div *ngFor="let key of getObjectKeys(row.igg_parameters)">
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.igg_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.inerting_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(row.inerting_parameters[0])
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.inerting_parameters
                        : [
                            row.inerting_parameters[
                              row.inerting_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(row.inerting_parameters[0])
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <div *ngIf="row.tank_cleaning_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(
                      row.tank_cleaning_avg_peak_parameters
                    )
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.tank_cleaning_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.tank_cleaning_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.tank_cleaning_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.tank_cleaning_electrical_load_parameters
                        : [
                            row.tank_cleaning_electrical_load_parameters[
                              row.tank_cleaning_electrical_load_parameters
                                .length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.tank_cleaning_electrical_load_parameters[0]
                        );
                        let i = index
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>{{ row.composite_boiler_consumption_per_day ?? row.domestic_boiler_consumption_per_day }}</td>
            <td>
              <table
                *ngIf="row.electrical_load_avg_peak_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of row.electrical_load_avg_peak_parameters[0]
                          | keyvalue
                      "
                    >
                      {{ key.value }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.electrical_load_avg_peak_parameters.slice(1)
                        : [
                            row.electrical_load_avg_peak_parameters[
                              row.electrical_load_avg_peak_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td *ngFor="let key of item | keyvalue">
                      {{ key.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <div *ngIf="row.idle_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(row.idle_avg_peak_parameters)
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.idle_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.idle_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.idle_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.idle_electrical_load_parameters
                        : [
                            row.idle_electrical_load_parameters[
                              row.idle_electrical_load_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.idle_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <div *ngIf="row.normal_sea_going_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(
                      row.normal_sea_going_avg_peak_parameters
                    )
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.normal_sea_going_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.normal_sea_going_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.normal_sea_going_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.normal_sea_going_electrical_load_parameters
                        : [
                            row.normal_sea_going_electrical_load_parameters[
                              row.normal_sea_going_electrical_load_parameters
                                .length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.normal_sea_going_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <div *ngIf="row.maneuvering_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(
                      row.maneuvering_avg_peak_parameters
                    )
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.maneuvering_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.maneuvering_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.maneuvering_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.maneuvering_electrical_load_parameters
                        : [
                            row.maneuvering_electrical_load_parameters[
                              row.maneuvering_electrical_load_parameters
                                .length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.maneuvering_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table
                *ngIf="row.maneuvering_technical_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.maneuvering_technical_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.maneuvering_technical_parameters
                        : [
                            row.maneuvering_technical_parameters[
                              row.maneuvering_technical_parameters.length - 1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.maneuvering_technical_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <div *ngIf="row.cargo_ops_avg_peak_parameters">
                <div
                  *ngFor="
                    let key of getObjectKeys(row.cargo_ops_avg_peak_parameters)
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.cargo_ops_avg_peak_parameters[key] }}
                </div>
              </div>
            </td>
            <td>
              <table
                *ngIf="row.cargo_ops_electrical_load_parameters?.length"
                class="inner-table"
              >
                <thead>
                  <tr>
                    <th
                      *ngFor="
                        let key of getObjectKeys(
                          row.cargo_ops_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of isExpanded
                        ? row.cargo_ops_electrical_load_parameters
                        : [
                            row.cargo_ops_electrical_load_parameters[
                              row.cargo_ops_electrical_load_parameters.length -
                                1
                            ]
                          ]
                    "
                  >
                    <td
                      *ngFor="
                        let key of getObjectKeys(
                          row.cargo_ops_electrical_load_parameters[0]
                        )
                      "
                    >
                      {{ item[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table *ngIf="row.tcp_parameters?.length" class="inner-table">
                <thead>
                  <tr>
                    <th *ngFor="let key of row.tcp_parameters[0] | keyvalue">
                      {{ key.value }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of row.tcp_parameters.slice(1);
                      let i = index
                    "
                    [hidden]="!isExpanded && i > 0"
                  >
                    <td *ngFor="let key of item | keyvalue">
                      {{ key.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td>
              <div *ngIf="row.vessel_speed_coefficients">
                <div
                  *ngFor="
                    let key of getObjectKeys(row.vessel_speed_coefficients)
                  "
                >
                  <strong>{{ formatLabel(key) }}:</strong>
                  {{ row.vessel_speed_coefficients[key] }}
                </div>
              </div>
            </td>
            <td>{{ row.power_packs_diesel }}</td>
            <td>{{ row.power_packs_electric }}</td>
            <td>{{ row.vessel_diversity_factor }}</td>
            <td>{{ row.vessel_status }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-right port-vessel-detail__footer">
      <button
        class="btn btn-light hover-button apply mt-2"
        (click)="resetFilter()"
      >
        Hide Details
      </button>
    </div>
  </div>

  </div>
</div>
